var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushEnviadas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 14.0833V6.50001C24.75 5.92537 24.5129 5.37427 24.091 4.96795C23.669 4.56162 23.0967 4.33334 22.5 4.33334H4.5C3.90326 4.33334 3.33097 4.56162 2.90901 4.96795C2.48705 5.37427 2.25 5.92537 2.25 6.50001V19.5C2.25 20.6917 3.2625 21.6667 4.5 21.6667H13.5M24.75 7.58334L14.6587 13.7583C14.3114 13.9679 13.9099 14.079 13.5 14.079C13.0901 14.079 12.6886 13.9679 12.3413 13.7583L2.25 7.58334M18 20.5833L20.25 22.75L24.75 18.4167",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushEnviadas);
export default __webpack_public_path__ + "static/media/push-enviadas.cef6d59dafafb7cc0a297b920e3b3e7b.svg";
export { ForwardRef as ReactComponent };